// import backgroundImg from '../media/updateBg.png';
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const usePlacementListStyles = makeStyles({
  placementListView: {
    marginLeft: '12px',
  },
  header: {
    display: 'flex',
    marginTop: '4px',
    marginBottom: '16px',
  },
  showRequiredOnlyCheckbox: {
    height: '32px',
  },
  // adControl: {
  //   display: 'flex',
  //   alignItems: 'center',
  //   justifyContent: 'space-between',
  //   marginRight: '24px',
  // },
  // adTypeControl: {
  //   display: 'flex',
  //   alignItems: 'center',
  //   margin: '24px 0',
  // },
  // controlBtn: {
  //   padding: '10px 0',
  //   fontFamily: 'Segoe UI',
  //   fontWeight: 400,
  //   fontSize: 14,
  //   lineHeight: '20px',
  //   color: palette.neutralPrimary,
  //   background: palette.white,
  //   border: 'none',
  //   marginRight: 24,
  // },
  // activeBtn: {
  //   borderBottom: `2px solid ${palette.blue}`,
  //   fontWeight: 600,
  // },
  // errorInfoBox: {
  //   margin: '-16px 24px 8px 0',
  //   background: '#FDE7E9',
  //   borderRadius: '6px',
  //   overflow: 'hidden',
  // },
  errorIcon: {
    color: '#A80000',
  },
  // errorInfo: {
  //   fontFamily: 'Segoe UI',
  //   fontWeight: 400,
  //   fontSize: 12,
  //   lineHeight: '16px',
  //   color: palette.neutralPrimary,
  // },
  // overlay: {
  //   position: 'absolute',
  //   top: 0,
  //   bottom: 0,
  //   left: 0,
  //   right: 0,
  //   zIndex: 1000,
  // },
  // toggleContainer: {
  //   display: 'flex',
  //   alignItems: 'flex-start',
  // },
  adPreviewWaterfallGridLayoutContainer: {
    marginRight: '24px',
  },
  adPreviewGridLayoutContainer: {
    gridTemplateColumns: 'repeat(auto-fill, minmax(674px, 0.7fr))',
  },
});

export const usePlacementContaierStyles = makeStyles({
  placementContainer: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '650px',
    minHeight: '490px',
    width: '100%',
    height: '100%',
    backgroundColor: tokens.white,
    boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.14), 0px 0px 2px 0px rgba(0, 0, 0, 0.12)',
    ...shorthands.borderRadius('4px'),
  },
  containerHeader: {
    ...shorthands.padding('16px', '16px', '0px', '16px'),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  containerTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  previewWrapper: {
    display: 'flex',
    alignItems: 'center',
    ...shorthands.padding('4px'),
    ...shorthands.borderRadius('4px'),
    backgroundColor: tokens.colorNeutralBackground5,
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '16px',
  },
  ratio: {
    marginLeft: '4px',
  },
  previewType: {
    marginLeft: '4px',
  },
  placementBox: {
    ...shorthands.margin('auto'),
  },
  requireBox: {
    marginLeft: '4px',
    ...shorthands.padding('4px'),
    ...shorthands.borderRadius('4px'),
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '16px',
    color: tokens.colorNeutralForeground3,
    backgroundColor: tokens.colorNeutralBackground5,
  },
  cropButton: {
    '&.fui-Button': {
      width: '24px',
      height: '24px',
      ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke1),
      ...shorthands.borderRadius('4px'),
      ...shorthands.padding('0px'),
      minWidth: '24px',
    },
  },
  errorIcon: {
    fontSize: '16px',
    lineHeight: '16px',
    marginLeft: '10px',
    color: '#A80000',
  },
  // errorContainer: {
  //   border: `1px solid ${palette.orange}`,
  // },
  // errRequireBox: {
  //   background: palette.orange,
  // },
  // errRequireText: {
  //   color: palette.white,
  // },
  minSize: {
    ...shorthands.margin('12px', 'auto'),
    fontFamily: 'Segoe UI',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    color: '#D83B01',
  },
  adPreviewComponentContainer: {
    minWidth: '650px',
    minHeight: '490px',
    animationDuration: '0.3s',
    animationTimingFunction: 'linear',
    animationName: [{
      from: {
        opacity: 0,
      },
      to: {
        opacity: 1,
      },
    }],
    boxSizing: 'border-box',
    marginBottom: '24px',
    marginRight: '24px',
  },
});


export const usePlacementContainerV2Styles = makeStyles({
  placementContainer: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '650px',
    minHeight: '490px',
    width: '100%',
    height: '100%',
    backgroundColor: tokens.white,
    boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.14), 0px 0px 2px 0px rgba(0, 0, 0, 0.12)',
    ...shorthands.borderRadius('4px'),
  },
  containerHeader: {
    ...shorthands.padding('12px', '16px', '0px', '16px'),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  containerTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  ratio: {
    marginRight: '8px',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '16px',
    ...shorthands.padding('4px'),
    ...shorthands.borderRadius('4px'),
    ...shorthands.border('1px', 'solid', 'rgba(224, 224, 224, 1)'),
  },
  previewType: {
    fontSize: '14px',
    lineHeight: '20px',
  },
  placementBox: {
    ...shorthands.margin('auto'),
  },
  requireBox: {
    ...shorthands.padding('4px'),
    ...shorthands.borderRadius('4px'),
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '16px',
    color: 'rgba(97, 97, 97, 1)',
    backgroundColor: 'rgba(235, 235, 235, 1)',
    marginRight: '6px',
  },
  cropButton: {
    '&.fui-Button': {
      ...shorthands.border('1px', 'solid', 'rgba(209, 209, 209, 1)'),
      ...shorthands.borderRadius('4px'),
      ...shorthands.padding('6px', '12px'),
      color: 'rgba(36, 36, 36, 1)',
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: '20px',
      minWidth: '0px',
    },
  },
  errorIcon: {
    fontSize: '16px',
    lineHeight: '16px',
    marginLeft: '10px',
    color: '#A80000',
  },
  rightBox: {
    display: 'flex',
    alignItems: 'center',
  },
  minSize: {
    marginBottom: '12px',
    fontFamily: 'Segoe UI',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    color: '#rgba(97, 97, 97, 1)',
  },
  adPreviewComponentContainer: {
    minWidth: '540px',
    animationDuration: '0.3s',
    animationTimingFunction: 'linear',
    animationName: [{
      from: {
        opacity: 0,
      },
      to: {
        opacity: 1,
      },
    }],
    boxSizing: 'border-box',
  },
  adPreviewPlacementContainer: {
    ...shorthands.padding('4px', '16px', '16px'),
    ...shorthands.margin('0px'),
  },
  cardBox: {
    display: 'flex',
    alignItems: 'center',
  },
});

export const getEditingModalStyles = (components, { palette = {} } = {}) => ({
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 99,
    background: 'rgba(255, 255, 255, 0.4)',
  },
  container: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: palette.white,
    borderRadius: '6px',
    boxShadow: '0px 4.8px 14.4px rgba(0, 0, 0, 0.18), 0px 25.6px 57.6px rgba(0, 0, 0, 0.22)',
    boxSizing: 'border-box',
    zIndex: 100,
    animation: 'fadeIn 0.3s linear',
    overflow: 'scroll',
    maxHeight: '100%',
    maxWidth: '100%',
  },
  fadeOut: {
    animation: 'fadeOut 0.3s linear',
  },
  hide: {
    opacity: 0,
    transition: 'all 0.3s linear',
  },
  '@global': {
    '@keyframes fadeIn': {
      from: {
        opacity: 0,
        width: 600,
        height: 300,
      },
      to: {
        opacity: 1,
        width: 1212,
        height: 650,
      },
    },
    '@keyframes fadeOut': {
      from: {
        opacity: 1,
        width: 1212,
        height: 650,
      },
      to: {
        opacity: 0,
        width: 600,
        height: 300,
      },
    },
  },
  closeIcon: {
    position: 'absolute',
    top: 16,
    right: 16,
    color: 'rgb(50, 49, 48)',
  },
  placementTitle: {
    marginTop: 32,
    marginLeft: 24,
    fontFamily: 'Segoe UI',
    fontWeight: 600,
    fontSize: 20,
    lineHeight: '27px',
    color: palette.neutralPrimary,
  },
  placementDesc: {
    marginTop: 16,
    marginLeft: 24,
    fontFamily: 'Segoe UI',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '20px',
    color: palette.neutralPrimary,
  },
  contentContainer: {
    marginTop: 7,
    marginLeft: 24,
    marginRight: 24,
    display: 'flex',
    alignItems: 'center',
  },
  previewContainer: {
    width: 650,
    height: 444,
    borderRadius: '6px',
    background: palette.neutralLighter,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 54,
  },
  footContainer: {
    marginTop: 39,
    padding: '16px 32px',
    width: '100%',
    boxSizing: 'border-box',
    borderTop: `1px solid ${palette.neutralLight}`,
  },
  cancelButton: {
    marginLeft: 8,
  },
});

export const useFlowTypeControlStyles = makeStyles({
  flowTypeBox: {
    display: 'flex',
  },
  typeButton: {
    ...shorthands.padding('6px', '12px'),
    ...shorthands.borderRadius('4px'),
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
    color: 'rgba(36, 36, 36, 1)',
    ...shorthands.border('1px', 'solid', 'rgba(209, 209, 209, 1)'),
    backgroundColor: 'white',
    minWidth: '0px',
  },
  selectedButton: {
    backgroundColor: 'rgba(235, 235, 235, 1)',
  },
  divider: {
    width: '1px',
    backgroundColor: 'rgba(224, 224, 224, 1)',
    ...shorthands.margin('0px', '10px'),
  },
  typeButtonBox: {
    display: 'flex',
    ...shorthands.gap('8px'),
  },
});
